import React from "react";
import { Column, theme } from "@dls/web";
import styled from "styled-components";

const InlineError = styled.div`
  background-color: ${theme.main.colours.primary.l3};
  color: ${theme.main.colours.tertiary.base};
  padding: 16px;
  font-size: ${theme.main.fontSizes.md};
  font-family: ${theme.main.fontFamily.secondaryThin};
`;

const InlineErrorMessage = ({ message }) => {
  return (
    <Column xs={12} md={6}>
      <InlineError>{message}</InlineError>
    </Column>
  );
};

export default InlineErrorMessage;
